import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    constructor(private toastr: ToastrService) {}

    showSuccess(title: string, message: string, options?: IndividualConfig) {
        this.toastr.success(message, title, options);
    }

    showWarnig(title: string, message: string, options?: IndividualConfig) {
        this.toastr.warning(message, title, options);
    }

    showInfo(title: string, message: string, options?: IndividualConfig) {
        this.toastr.info(message, title, options);
    }

    showError(title: string, message: string, options?: IndividualConfig) {
        this.toastr.error(message, title, options);
    }

    showSwalError(title: string, message: string) {
        Swal.fire({
            title: title,
            text: message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false, // Prevents closing on outside click
            allowEscapeKey: false,    // Prevents closing on 'Escape' key press
            allowEnterKey: false,     
        });
    }

    showSwalSuccess(title: string, message: string) {
        Swal.fire({
            title: title,
            text: message,
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false, // Prevents closing on outside click
            allowEscapeKey: false,    // Prevents closing on 'Escape' key press
            allowEnterKey: false,     
        });
    }
    showSwalSuccessV2(title: string, htmlContent: string) {
    Swal.fire({
        title: title,
        html: htmlContent,
        icon: 'success',
    });
}
}
